/* eslint-disable react/display-name */
import { memo, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import {
  TaxpayerRequestStoreProvider,
  useTaxpayerRequestStore
} from '../../stores/useTaxpayerRequestStore';
import { TaxpayerRequest } from '../../TaxpayerRequest';
import { useGetTaxPayerRequest } from '../../TaxpayerRequest/hooks';

export const TaxpayerEditRequest = memo(() => {
  return (
    <TaxpayerRequestStoreProvider>
      <TaxpayerEditRequestContent />
    </TaxpayerRequestStoreProvider>
  );
});

const TaxpayerEditRequestContent = () => {
  const { id } = useParams();
  const [{ data, loading, error }] = useGetTaxPayerRequest(id || '');
  const setRequest = useTaxpayerRequestStore((s) => s.setRequest);

  useEffect(() => {
    if (data) {
      setRequest(data.recordData);
    }
  }, [data, setRequest]);

  if (loading || error) {
    return <></>;
  }

  return <TaxpayerRequest />;
};
